"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.ICON_TYPE = exports.ICON_SIZE = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _typographyModule = _interopRequireDefault(require("../../styles/typography.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ICON_TYPE = exports.ICON_TYPE = Object.freeze({
  regular: 'regular',
  solid: 'solid',
  duotone: 'duotone',
  brands: 'brands'
});
const ICON_SIZE = exports.ICON_SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});
const Icon = exports.Icon = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    type = 'regular',
    name = '',
    size = 'medium',
    color = _typography.TEXT_COLORS.primary,
    className,
    style,
    onClick,
    swapOpacity,
    testId = 'icon'
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !!name && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'icon'
      }),
      className: (0, _classify.default)(_typographyModule.default.centerAlignFlex, _typographyModule.default[`${size}Icon`], _typographyModule.default[color], className),
      onClick: onClick,
      ref: forwardRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: (0, _classify.default)(`fa-${type} fa-${name} `, {
          ['fa-swap-opacity']: swapOpacity
        }),
        style: style
      })
    })
  });
});